module.exports = __webpack_public_path__ + "img/sv3.b6c4aca.png";